export function contactBtn() {
  var check = $('#jsCheck').length;
  if (check) {
    $(".wpcf7-submit").prop("disabled", true);
    $(".wpcf7-submit").css("pointer-events", "none");
    $(".wpcf7-submit").css("background-color", "#ddd");

    $('input:checkbox[name="checkbox[]"]').on('click', function () {
      var select = $('input:checkbox[name="checkbox-billing[]"]:checked').val();
      var txtArea = $('#texs').val();
      
      if (select == "その他" && !txtArea) {
        alert("備考欄に入力してください。");
        $('input:checkbox[name="checkbox[]"]').prop('checked', false);
      } else {
          $('.wpcf7-submit').removeAttr('style');
          $(".wpcf7-submit").prop("disabled", false);
      }
    });

  }
}